import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  SET_REQUEST_PARAMS,
  SET_COLLECTION,
  LOADING_STATE,
  ERROR_STATE,
} from './AccountActions';

const AccountStateContext = React.createContext(undefined);
const AccountDispatchContext = React.createContext(undefined);
const defaultState = {
  requestParams: {},
  accountCollection: null,
  loading: false,
  error: null,
};

function init(state) {
  return {
    ...defaultState,
    ...state,
  };
}

function reducer(state, action) {
  switch (action.type) {
    case SET_REQUEST_PARAMS: {
      const { params } = action;

      return {
        ...state,
        requestParams: params,
      };
    }
    case SET_COLLECTION: {
      const { collection } = action;

      return {
        ...state,
        accountCollection: collection,
        loading: false,
      };
    }
    case LOADING_STATE: {
      const { loading } = action;

      return {
        ...state,
        loading,
      };
    }
    case ERROR_STATE: {
      const { error } = action;

      return {
        ...state,
        error,
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function AccountProvider({ children, initialState }) {
  const [state, dispatch] = React.useReducer(reducer, initialState, init);

  return (
    <AccountStateContext.Provider value={state}>
      <AccountDispatchContext.Provider value={dispatch}>
        {children}
      </AccountDispatchContext.Provider>
    </AccountStateContext.Provider>
  );
}

function useAccountStateContext() {
  const context = React.useContext(AccountStateContext);

  if (context === undefined) {
    throw new Error(
      'useAccountStateContext must be used within a AccountProvider',
    );
  }

  return context;
}

function useAccountDispatchContext() {
  const context = React.useContext(AccountDispatchContext);

  if (context === undefined) {
    throw new Error(
      'useAccountDispatchContext must be used within a AccountProvider',
    );
  }

  return context;
}

AccountProvider.defaultProps = {
  initialState: defaultState,
};

AccountProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  initialState: PropTypes.shape({
    error: PropTypes.instanceOf(Error),
    loading: PropTypes.bool,
    accountCollection: PropTypes.instanceOf(fr.Collection),
  }),
};

export { AccountProvider, useAccountStateContext, useAccountDispatchContext };
